import React from 'react';

export default (
  <path
    d="M16.3,1.7c0-0.3-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.4-0.9-0.4H4.3C3.6,0.4,3,0.7,2.5,1.1C2,1.6,1.7,2.3,1.7,2.9
	v12.9c0,0.7,0.3,1.3,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7h11.4c0.3,0,0.5-0.2,0.6-0.4c0.1-0.2,0-0.5-0.2-0.7c-0.2-0.2-0.3-0.4-0.4-0.6
	c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0-0.5,0.1-0.8c0.1-0.2,0.2-0.5,0.4-0.6l0,0l0,0l0,0l0,0l0.1-0.1c0,0,0,0,0,0
	c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1V1.7z M15,13.4l-9.1,0V1.7H15V13.4z M3.4,2c0.2-0.2,0.6-0.4,0.9-0.4h0.4v11.7
	l-0.4,0h0c-0.4,0-0.9,0.1-1.3,0.4V2.9C3,2.6,3.1,2.3,3.4,2z M4.3,17.1c-0.3,0-0.7-0.1-0.9-0.4C3.1,16.5,3,16.2,3,15.9
	c0-0.3,0.1-0.7,0.4-0.9c0.2-0.2,0.6-0.4,0.9-0.4c0,0,0,0,0,0l10.2,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.1,0.2-0.1,0.4-0.2,0.7H7.6
	c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h6.7c0,0.3,0.1,0.5,0.2,0.8H4.3z M7.6,6.8h6c0.3,0,0.5-0.2,0.5-0.5V3.8
	c0-0.3-0.2-0.5-0.5-0.5h-6c-0.3,0-0.5,0.2-0.5,0.5v2.5C7.1,6.5,7.3,6.8,7.6,6.8z M8,4.2h5v1.6H8V4.2z"
  />
);
